<template>
  <PortalPageShell
    title="Airline Manager"
    :subtitle="$t('portal.airlineManager')"
  >
  <div class="portal-page-fill airline-details">
    <div class="airline-manager" v-if="refinedAirlines">
      <div class="top-header toolbar-card">
        <div class="search">
          <div class="icon">
            <span class="mdi mdi-magnify"></span>
          </div>
          <input
            class="search-bar"
            :placeholder="'search airline'"
            v-model="search"
          />
        </div>
        <div class="filters-container" >
          <GateTabs :value="filter" @update="updatefilter"/>
        </div>
        <div class="create-airline">
          <span
            v-if="this.permissions.includes('Create-Airline')"
            @click="createAirline"
            class="mdi mdi-plus-circle-outline  add"
          ></span>
        </div>
      </div>
    </div>
    <div class="airline-reports portal-reports">
      <h6 class="report-title">
        Airline Add/Delete Reports:
        <date-picker
          v-model="selectedDate"
          range
          :format="dateFormat"
          :placeholder="[[currentDate]] + ' ~ ' + [[currentDate]]"
        ></date-picker>
        <input
          class="radio-btn"
          type="radio"
          id="PDF"
          value="pdf"
          v-model="fileFormat"
        />
        <label for="PDF">PDF</label>
        <input
          class="radio-btn"
          type="radio"
          id="CSV"
          value="csv"
          v-model="fileFormat"
        />
        <label for="CSV">CSV</label>
        <input
          class="radio-btn"
          type="radio"
          id="EXCEL"
          value="xlsx"
          v-model="fileFormat"
        />
        <label for="EXCEL">EXCEL</label>
        <button class="btn btn-primary float-right report-btn"  @click="downloadReports">
          Download Reports
        </button>
      </h6>
    </div>
    <div ref="airlineTable" class="airline-table portal-table-wrap table-card">
      <div class="portal-table-scroll">
        <table class="table">
        <thead>
          <tr class="table-header">
            <th
              class="user-table-headers"
              :class="[{ sorting: sort == 'code' }, direction]"
              @click="updateSort('code')"
            >
              Code
            </th>
            <th
              class="user-table-headers"
              :class="[{ sorting: sort == 'name' }, direction]"
              @click="updateSort('name')"
            >
              Name
            </th>
            <th class="user-table-headers">
              Logo
            </th>
            <th
              class="user-table-headers"
              :class="[{ sorting: sort == 'status' }, direction]"
              @click="updateSort('status')"
            >
              {{ $t('gate.status') }}
            </th>
            <th
              class="user-table-headers"
              v-if="
                this.permissions.includes('Edit-Airline') ||
                this.permissions.includes('Delete-Airline')
              "
            >
              Action
            </th>
          </tr>
        </thead>
        <PortalTableBody
          :loading="loading"
          variant="airline"
          :show-actions="hasActionColumn"
        >
        <template
          v-if="
            !this.permissions.includes('Edit-Airline') &&
            !this.permissions.includes('Delete-Airline')
          "
        >
          <tr v-for="(item, idx) in refinedAirlines" :key="idx">
            <td>{{ item.code }}</td>
            <td>{{ formatName(item.name) }}</td>
            <td>
              <img
                :src="getLogoSrc(item)"
                class="airline-logo-icon"
                :alt="formatName(item.name) + ' logo'"
                @error="onImgError"
              />
            </td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
          </tr>
        </template>

        <template
          v-else-if="
            this.permissions.includes('Edit-Airline') &&
            this.permissions.includes('Delete-Airline')
          "
        >
          <tr v-for="(item, idx) in refinedAirlines" :key="idx">
            <td>{{ item.code }}</td>
            <td>{{ formatName(item.name) }}</td>
            <td>
              <img
                :src="getLogoSrc(item)"
                class="airline-logo-icon"
                :alt="formatName(item.name) + ' logo'"
                @error="onImgError"
              />
            </td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
            <td v-if="!airlineKey.includes('admin') ">
              <!-- {{ refinedAirlines }} -->
              <div class="row d-flex justify-content-center" v-if="checkAirlineAction(item.name)">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editAirlineDetails(idx)"
                  ></span>
                </div>
                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(idx)"
                  ></span>
                </div>
              </div>
            </td>
            <td v-else>
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editAirlineDetails(idx)"
                  ></span>
                </div>
                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(idx)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>

        <template
          v-else-if="
            this.permissions.includes('Delete-Airline') &&
            !this.permissions.includes('Edit-Airline')
          "
        >
          <tr v-for="(item, idx) in refinedAirlines" :key="idx">
            <td>{{ item.code }}</td>
            <td>{{ formatName(item.name) }}</td>
            <td>
              <img
                :src="getLogoSrc(item)"
                class="airline-logo-icon"
                :alt="formatName(item.name) + ' logo'"
                @error="onImgError"
              />
            </td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
            <td v-if="!airlineKey.includes('admin')">
              <div class="row d-flex justify-content-center" v-if="checkAirlineAction(item.name)">
                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(idx)"
                  ></span>
                </div>
              </div>
            </td>
            <td v-else>
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(idx)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>

        <template
          v-else-if="
            this.permissions.includes('Edit-Airline') &&
            !this.permissions.includes('Delete-Airline')
          "
        >
          <tr v-for="(item, idx) in refinedAirlines" :key="idx">
            <td>{{ item.code }}</td>
            <td>{{ formatName(item.name) }}</td>
            <td>
              <img
                :src="getLogoSrc(item)"
                class="airline-logo-icon"
                :alt="formatName(item.name) + ' logo'"
                @error="onImgError"
              />
            </td>
            <td v-if="item.is_active == 0">Disabled</td>
            <td v-else>Enabled</td>
            <td v-if="!airlineKey.includes('admin')">
              <div class="row d-flex justify-content-center" v-if="checkAirlineAction(item.name)">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editAirlineDetails(idx)"
                  ></span>
                </div>
              </div>
            </td>
            <td v-else>
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editAirlineDetails(idx)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>
        </PortalTableBody>
      </table>
      </div>
    </div>
    <div class="footer portal-footer">
      <div class="results">
        <span class="mdi mdi-format-list-bulleted results-icon" aria-hidden="true"></span>
        {{ $t("displayresults.display") }} <strong>{{ resultsCopy }}</strong> {{ $t("displayresults.results")}}
      </div>
    </div>
    <!-- Pop Up Modal -->
    <div v-if="myModel">
      <transition name="model">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click="myModel = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="confirmation pb-4" style="text-align: center">
                    <h4>{{ $t('deletepop.message') }}</h4>
                  </div>
                  <div align="center">
                    <input
                      type="button"
                      class="btn btn-primary"
                      style="margin-right: 10px; width: 100px"
                      :value="$t('deletepop.okbtn')"
                      @click="deleteAirline(modalData)"
                    />
                    <input
                      type="button"
                      class="btn btn-danger"
                      style="margin-left: 10px; width: 100px"
                      :value="$t('deletepop.cancelbtn')"
                      @click="myModel = false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
  </PortalPageShell>
</template>
<script>
import PortalPageShell from '../layout/PortalPageShell.vue';
import axios from 'axios';
import moment from 'moment';
import { decryptData } from '../../js/utils/encrypt';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { routeNames } from '../../js/routeNames';
import GateTabs from '../GateTabs.vue';
import PortalTableBody from '../PortalTableBody.vue';
import defaultLogo from '../../assets/default_logo.png';

export default {
  data: function () {
    return {
      loading: false,
      myModel: false,
      airlineData: '',
      permissions: [],
      modalData: '',
      search: '',
      filter: 'all',
      model: false,
      selectedDate: '',
      fileFormat: 'pdf',
      test1: false,
      test2: false,
      test3: false,
      date: '',
      currentDate: '',
      dateFormat: 'YYYY-MM-DD',
      userName: '',
      airlineKey: [],
      imageCacheBust: 0,
      defaultLogo
    };
  },
  components: {
    PortalPageShell,
    DatePicker,
    GateTabs,
    PortalTableBody
  },
  props: {
    direction: String,
    sort: String,
  },
  watch: {
    '$route.name'(newName) {
      if (newName === routeNames.manageAirline) {
        this.loading = true;
        this.getAirline(true);
      }
    }
  },
  computed: {
    refinedAirlines() {
      if (!Array.isArray(this.airlineData)) {
        return [];
      }
      let refined = this.filterAirlines(this.airlineData);
      refined = this.searchAirlines(refined);
      if (this.sort) {
        refined = this.sortAirlines(refined);
      }
      return this.direction === 'ascending' ? refined : refined.slice().reverse();
    },
    routeNames: () => {
      return routeNames;
    },
    resultsCopy() {
      const length = this.refinedAirlines.length;
      return `${length}`; 
    },
    hasActionColumn() {
      return (
        this.permissions.includes('Edit-Airline') ||
        this.permissions.includes('Delete-Airline')
      );
    }
  },
  mounted() {
    var airline = localStorage.getItem('Airline');
    if (!airline) {
      airline = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    var airlineArray = decryptData(airline, secretPermissionKey);
    if (!Array.isArray(airlineArray) || airlineArray.length === 0) {
      this.airlineKey.push('admin');
    } else {
      for (let i = 0; i < airlineArray.length; i++) {
        this.airlineKey.push(airlineArray[i].name);
      }
    }
    let today = new Date();
    this.currentDate = moment(today).format(this.dateFormat);
    this.userName = localStorage.getItem('username').replace(/['"]+/g, '');

    //Decrypting Permissions
    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    this.permissions = decryptData(mkLocalData, secretPermissionKey);
    (this.loading = true),
      axios
        .get(this.$hostName + '/airlines/details')
        .then((response) => {
          this.airlineData = Array.isArray(response.data) ? response.data : [];
          this.imageCacheBust = Date.now();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    refreshPortalPage() {
      this.loading = true;
      axios
        .get(this.$hostName + '/airlines/details')
        .then((response) => {
          this.airlineData = Array.isArray(response.data) ? response.data : [];
          this.imageCacheBust = Date.now();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getLogoSrc(item){
      if (item && item.logo_dark_large) {
        return this.logoUrl(item.logo_dark_large, item.updated_at);
      }
      return this.defaultLogo;
    },
    onImgError(e){
      if (e && e.target) {
        e.target.src = this.defaultLogo;
        e.target.onerror = null;
      }
    },
    hideImg(e){
      if (e && e.target) {
        e.target.style.display = 'none';
      }
    },
    logoUrl(fileName, updatedAt){
      if (!fileName) {
        return this.defaultLogo;
      }
      const base = process.env.VUE_APP_AIRLINE_IMAGES_BASE || process.env.VUE_APP_IMAGES_BASE || '';
      let url = fileName;
      if (!/^https?:\/\//i.test(fileName) && base) {
        const trimmed = base.replace(/\/$/, '');
        url = `${trimmed}/${String(fileName).replace(/^\//, '')}`;
      }
      const ver = updatedAt || this.imageCacheBust;
      if (ver) {
        const ts = new Date(ver).getTime() || Date.now();
        const sep = url.includes('?') ? '&' : '?';
        url = `${url}${sep}t=${ts}`;
      }
      // Fallback: if the API already returns absolute URLs or the asset is public
      return url;
    },
    checkAirlineAction(airlineData){
      // for(let i=0; i<airlineData.length; i++){
        if(this.airlineKey.includes(airlineData)){
          console.log('hereeee',airlineData);
          return true;
        }
      // }
      return false;
    },
    formatName(name){
      if(name == null ){
        return name;
      }
      return name.split(/(?=[A-Z])/).join(' ');
    },
    updatefilter(value) {
      this.filter = value;
    },
    updateSort(value) {
      this.$emit('updateSort', value);
    },
    filterAirlines(data) {
      const rows = Array.isArray(data) ? data : [];
      if (this.filter != 'all') {
        return rows.filter((airline) => {
          return airline.is_active.toString().toLowerCase() == this.filter;
        });
      }
      return rows;
    },
    searchAirlines(data) {
      const rows = Array.isArray(data) ? data : [];
      if (!this.search) return rows;
      return rows.filter((airline) => {
        return (
          airline.code && airline.code.toString().toLowerCase().includes(this.search.toString().toLowerCase()) ||
          airline.name && airline.name.toString().toLowerCase().includes(this.search.toString().toLowerCase())
        );
      });
     
    },
    sortAirlines(data) {
      const rows = Array.isArray(data) ? data.slice() : [];
      switch (this.sort) {
        case 'name':
        case 'status':
        case 'code':
          return rows.sort((airlineA, airlineB) => {
            if (airlineA[this.sort] < airlineB[this.sort]) {
              return -1;
            }
            if (airlineA[this.sort] > airlineB[this.sort]) {
              return 1;
            }
            return 0;
          });
        default:
          return rows;
      }
    },
    downloadReports() {
      const fromDate = moment(this.selectedDate[0]).format('YYYY-MM-DD');
      const toDate = moment(this.selectedDate[1]).format('YYYY-MM-DD');
      const fileType = this.fileFormat;
      var formData = {
        fDate: fromDate,
        tDate: toDate,
        filter: this.filter,
        uName: this.userName,
        rName: 'Airline List',
        rType: 'airline',
        fType: fileType,
      };
      this.loading = true;
      axios({
        url: this.$hostName + '/downloadReport',
        method: 'POST',
        responseType: 'blob',
        data: formData,
      })
        .then((response) => {
          const binaryResponse = new Blob([response.data]);
          if (binaryResponse.size > 10) {
            var fileURL = window.URL.createObjectURL(binaryResponse);
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            var fileName =
              'Airline_' +
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
              '.' +
              fileType;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
          } else {
            this.$alert('No data for the selected filter criteria');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteAirline(idx) {
      this.loading = true;
      axios
        .delete(
          // this.$hostName + '/airlines/' + this.airlineData[idx].id
            this.$hostName + '/airlines/' + this.refinedAirlines[idx].id
        )
        .then((response) => {
          if (response.status == 200) {
            this.myModel = false;
            this.$emit('Airline Deleted');
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getAirline();
        });
    },
    editAirlineDetails(idx) {
      var name = this.refinedAirlines[idx].name;
      var code = this.refinedAirlines[idx].code;
      var id = this.refinedAirlines[idx].id;
      var code_type = this.refinedAirlines[idx].code_type;
      var is_active = this.refinedAirlines[idx].is_active;
      var logo_dark_large = this.refinedAirlines[idx].logo_dark_large;
      var logo_dark_small = this.refinedAirlines[idx].logo_dark_small;
      var logo_light_large = this.refinedAirlines[idx].logo_light_large;
      var logo_light_small = this.refinedAirlines[idx].logo_light_small;
      this.$router.push({
        name: 'edit-airline',
        params: {
          name,
          code,
          code_type,
          is_active,
          id,
          logo_dark_large,
          logo_dark_small,
          logo_light_large,
          logo_light_small
        },
      });
    },
    openModel(idx) {
      this.myModel = true;
      this.modalData = idx;
    },
    reportsModel() {
      this.model = true;
    },
    getAirline(silent) {
      axios
        .get(this.$hostName + '/airlines/details')
        .then((response) => {
          this.airlineData = response.data;
          this.imageCacheBust = Date.now();
        })
        .finally(() => {
          this.loading = false;
          if (!silent) {
            this.$alert('Airline removed succesfully');
          }
        });
    },
    createAirline() {
      this.$router.push({ name: routeNames.newAirline });
    },
  },
};
</script>
<style scoped lang="scss">
.footer {
    width: 100%;
    height: 60px;
    min-height: 60px;
    background-color: $general-gray-light;
    padding: 0 25px;
    border-top: solid 1px $general-white;
    position: static; /* allow page to scroll normally */
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .results {
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-right: 20px;
      color: $general-black-light;
    }
  }
.radio-btn {
  margin-left: 5%;
}
.airline-reports {
  background-color: #f0f7ff;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-left: 1%;
  margin-right: 1%;
}
.report-title {
  margin-left: 2%;
}
.report-btn {
  margin-right: 2%;
}
tr {
  text-align: center;
}
td {
  text-align: center;
  vertical-align: baseline !important;
}
.airline-table {
  min-height: 0;
}
.table th, .table td {
  padding: 8px 10px;
}
.table-header th {
  white-space: nowrap;
}
/* Column sizing: Code | Name | Logo | Status | Action */
.table thead th:nth-child(1),
.table tbody td:nth-child(1) { /* Code */
  width: 90px;
}
.table thead th:nth-child(2),
.table tbody td:nth-child(2) { /* Name */
  min-width: 180px;
  text-align: left;
}
.table thead th:nth-child(3),
.table tbody td:nth-child(3) { /* Logo */
  width: 90px;
}
.table thead th:nth-child(4),
.table tbody td:nth-child(4) { /* Status */
  width: 110px;
}
.table thead th:nth-child(5),
.table tbody td:nth-child(5) { /* Action */
  width: 140px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-content {
  width: 500px !important;
}
.icon {
  font-size: 25px;
  display: flex;
  align-items: center;
}
.edit {
  color: #007bff;
  top: 5px;
  margin-right: 10px;
}
.edit:hover {
  cursor: pointer;
}
.delete {
  color: red;
  margin-left: 10px;
}
.delete:hover {
  cursor: pointer;
}
.airline-logo-icon {
  width: 60px;
  height: 50px;
  margin-left: 6px;
  object-fit: contain;
  vertical-align: middle;
  flex-shrink: 0;
}
.add:hover {
  cursor: pointer;
}
.title {
  display: flex;
  justify-content: center;
}
.airline-header {
  margin-top: 2%;
  margin-bottom: 2%;
  margin-left: 5%;
  margin-right: 5%;
}
.airline-manager {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Laptop screens: compact layout */
@media (max-width: 1366px) {
  .table th, .table td { padding: 6px 8px; font-size: 13px; }
  .table thead th:nth-child(1),
  .table tbody td:nth-child(1) { width: 80px; }
  .table thead th:nth-child(2),
  .table tbody td:nth-child(2) { min-width: 160px; }
  .table thead th:nth-child(3),
  .table tbody td:nth-child(3) { width: 80px; }
  .table thead th:nth-child(4),
  .table tbody td:nth-child(4) { width: 100px; }
  .table thead th:nth-child(5),
  .table tbody td:nth-child(5) { width: 120px; }
  .airline-logo-icon { width: 50px; height: 40px; }
  .user-table-headers { font-size: 13px; }
  .report-title { font-size: 13px; }
}

@media (max-width: 1200px) {
  .table th, .table td { padding: 6px 6px; }
  .airline-logo-icon { width: 46px; height: 36px; }
}
</style>
